/**
 * Created by 叶子 on 2017/7/30.
 * http通用工具函数
 */
import axios from 'axios';
import { message } from 'antd';
import * as config1 from './config';

interface IFRequestParam {
    url: string;
    msg?: string;
    config?: any;
    data?: any;
}
/**
 * 公用get请求
 * @param url       接口地址
 * @param msg       接口异常提示
 * @param headers   接口所需header配置
 */
export const get = ({ url, msg = '接口异常', config }: IFRequestParam) =>
    axios
        .get(url, config)
        .then((res) => res.data)
        .catch((err) => {
            console.log(err);
            message.warn(msg);
        });

/**
 * 公用post请求
 * @param url       接口地址
 * @param data      接口参数
 * @param msg       接口异常提示
 * @param headers   接口所需header配置
 */
export const post = ({ url, data, msg = '接口异常', config }: IFRequestParam) =>
    axios
        .post(url, data, config)
        .then((res) => res.data)
        .catch((err) => {
            console.log(err);
            message.warn(msg);
        });

/**
* 公用get请求
* @param url       接口地址
* @param msg       接口异常提示
* @param headers   接口所需header配置
*/
export const getCommon = ({ url, msg = '接口异常' }: IFRequestParam) => {
    const token = localStorage.getItem("token");
    let Authorization = '';
    if (token) Authorization = `Bearer ${token}`;
    return axios
        .get(url, {
            headers: { 'Authorization': Authorization }
        })
        .then((res) => {
            // console.log("res:" + JSON.stringify(res));
            if (res.data.code === '200') {
                return res.data;
            } else if (res.data.code === '403') {
                message.info(res.data.message);
            } else {
                // message.error("接口调用异常");
                message.info(res.data.message);
                return res.data;
            }
        })
        .catch((err) => {
            if (err && err.response && err.response.status === 401) {
                // token失效跳转到登录页面
                localStorage.removeItem("token");
                message.error("登录失效，请重新登录");
                window.location.replace("#/login");
            } else {
                message.error("网络错误");
            }
        }
        )
};

/**
* 公用post请求
* @param url       接口地址
* @param data      接口参数
* @param msg       接口异常提示
* @param headers   接口所需header配置
*/
export const postCommon = ({ url, data, msg = '接口异常' }: IFRequestParam) => {
    const token = localStorage.getItem("token");
    let Authrization = '';
    if (token) Authrization = `Bearer ${token}`;
    // axios.interceptors.request.use(function (config) {
    //     return config;
    //   }, function (error) {
    //     return Promise.reject(error);
    //   });
    //   axios.interceptors.response.use(function (response) {
    //     console.log("xxxxfh："+JSON.stringify(response));
    //     if(response.data.code ==='403'){
    //         return Promise.resolve(response);
    //     }
    //     return response;
    //   }, function (error) {
    //     return Promise.reject(error);
    //   });
    return axios
        .post(url, data, {
            headers: { 'Authorization': Authrization }
        })
        .then((res) => {
            if (res.data.code === '200') {
                return res.data;
            } else if (res.data.code === '403') {
                message.info(res.data.message);
            } else {
                // message.error("接口调用异常");
                message.info(res.data.message);
                return res.data;
            }
        })
        .catch((err) => {
            if (err && err.response && err.response.status === 401) {
                // token失效跳转到登录页面
                localStorage.removeItem("token");
                message.error("登录失效，请重新登录");
                window.location.replace("#/login");
            } else {
                message.error("网络错误");
            }
        })
};

//     /**
// * 公用post请求
// * @param url       接口地址
// * @param data      接口参数
// * @param msg       接口异常提示
// * @param headers   接口所需header配置
// */
// export const postCommonWithoutToken = ({ url, data, msg = '接口异常' }: IFRequestParam) =>{
//     return axios
//         .post(url, data)
//         .then((res) => {
//             if (res.data.success) {
//                 return res.data;
//             } else {
//                 message.error("接口调用异常");
//             }
//         })
//         .catch((err) => {
//             console.log(err);
//             message.warn(msg);
//         })
//     };